export default "__VITE_ASSET__CMDk93Y8__"